/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import Animation from 'modules/animation-timeline';
import AnimationScroll from 'modules/animation-scroll';
import container from 'modules/section-content';
import './plugins/stalkerMenu';
import splash from './view/landing.pug';
import metadata from './metadata.json';
import animationUnify from './animations/unify/data.json';
import animationPersonalize from './animations/personalize/data.json';
import animationSubscriptions from './animations/subscriptions/data.json';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/healthcare', render, snippets);
  page.exit('/healthcare', unmountContactForm, resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="Media & Publishing"
      subject="New lead from Media & Publishing landing page"
      formId="healthcare-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupContactForm();
  $('.stalker-menu-container').stalkerMenu();
  setupVideoAnimations();
  next();
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  next();
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:healthcare-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:healthcare-contact-form', metricsData);
    },
    source: 'healthcare-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}

function setupVideoAnimations() {
  const heroAnimation = setupHeroAnimation();
  const phiVideo = document.getElementById('phi-video');
  const unifyVideo = document.getElementById('unify-video');
  const patientPortalVideo = document.getElementById('patient-portal-video');
  const federationVideo = document.getElementById('federation-video');

  heroAnimation.run();
  animationScroll.addScrollSpy({
    id: 'phi-section',
    onEnter: () => phiVideo.play(),
    oneShot: true
  });

  animationScroll.addScrollSpy({
    id: 'unify-section',
    onEnter: () => unifyVideo.play(),
    oneShot: true
  });

  animationScroll.addScrollSpy({
    id: 'patient-portals-section',
    onEnter: () => patientPortalVideo.play(),
    oneShot: true
  });

  animationScroll.addScrollSpy({
    id: 'federation-section',
    onEnter: () => federationVideo.play(),
    oneShot: true
  });

  animationScroll.start();
}

function setupHeroAnimation() {
  const $elem = $('.healthcare-page section[role="hero"] .hero-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .removeClass('step-01 step-02 step-03 step-04 step-05 step-06')
    .fadeIn(300)
    .delay(400)
    .toggleClass('step-01')
    .delay(300)
    .toggleClass('step-02')
    .delay(450)
    .toggleClass('step-03')
    .delay(300)
    .toggleClass('step-04')
    .delay(900)
    .toggleClass('step-05')
    .delay(200)
    .toggleClass('step-06')
    .delay(200)
    .toggleClass('step-07')
    .delay(100)
    .toggleClass('step-08')
    .delay(100)
    .toggleClass('step-09')
    .delay(200)
    .toggleClass('step-10')
    .delay(100)
    .toggleClass('step-11')
    .delay(200)
    .toggleClass('step-12')
    .delay(100)
    .toggleClass('step-13')
    .delay(200)
    .toggleClass('step-14');
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}



// WEBPACK FOOTER //
// ./src/pages/healthcare/client.js